const columnData = [
  {
    header: "سال زراعی",
    accessorKey: "crop_year_name",
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: "نام کشاورز",
    accessorKey: "farmer_name",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => <span className="flex">جمع بار تحویلی <span className="text-blue-600">(تن)</span></span>,
    accessorKey: "sum_delivered_load",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => <span className="flex">وزن سهمیه شکر <span className="text-blue-600">(کیلوگرم)</span></span>,
    accessorKey: "sugar_quota_weight",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => <span className="flex">مبلغ سهمیه شکر <span className="text-blue-600">(تومان)</span></span>,
    accessorKey: "sugar_quota_price",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => <span className="flex">شکر تحویلی <span className="text-blue-600">(کیلوگرم)</span></span>,
    accessorKey: "sugar_delivered",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
  {
    header: () => <span className="flex">مبلغ واریزی شکر <span className="text-blue-600">(تومان)</span></span>,
    accessorKey: "sugar_deposit_amount",
    enableColumnFilter: false,
    cell: ({ getValue }: { getValue: () => any }) => {
      const value = getValue();
      return value ? value.toLocaleString("fa-IR") : "0";
    },
  },
];
export default columnData;
